import React from 'react'
import styled from 'styled-components'

import { swaapMiddleRed1, swaapRed2 } from '../Themes'

interface Props {
  children: string
  className?: string
}
export const ErrorMessage: React.FC<Props> = ({
  children,
  className,
}: Props) => {
  const messages = children
    .split('\n')
    .map(m => m.trim())
    .filter(m => m.length > 0)

  return (
    <Wrapper className={className}>
      {messages.map((m, index) => (
        <p style={{ margin: 0 }} key={index}>
          {m}
        </p>
      ))}
    </Wrapper>
  )
}

export const Wrapper = styled.div`
  justify-content: center;
  font-size: 1.75rem;
  padding: 1rem 1.75rem;
  color: ${swaapRed2};
  background-color: ${swaapMiddleRed1};
  border-radius: 1.75rem;
`
